import React from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { TableCell, TableRow } from '@material-ui/core';
import { Discount } from '../../../../server-types';
import Query from '../../../../graphql/Query';
import { GET_DISCOUNTS } from '../../graphql';
import { HoverLink, Table } from '../../../../ui-kit';
import { HeadCell } from '../../../../ui-kit/Table/types';
import { translate } from '../../../../utils';

interface DiscountsTableQueryResult {
    discounts: Array<Discount>;
}

const headCells: Array<HeadCell<Pick<Discount, 'description' | 'name' | 'rate'>>> = [
    { id: 'name', align: 'left', disablePadding: true, label: translate('Name') },
    { id: 'rate', align: 'right', disablePadding: false, label: translate('Discount') },
];

const DiscountTable = () => {
    const match = useRouteMatch();
    const history = useHistory();
    const referrer = `${history.location.pathname}${history.location.search}`;

    return (
        <Query<DiscountsTableQueryResult> query={GET_DISCOUNTS}>
            {({ data: { discounts } }) => {
                const children = discounts.map(row => (
                    <TableRow tabIndex={-1} key={row.id}>
                        {headCells.map(({ id, align }) => {
                            const discountUrl = `${match.url}/${row.id}`;

                            return (
                                <TableCell
                                    key={id} id={id}
                                    align={align}
                                >
                                    <HoverLink wide to={{ pathname: discountUrl, state: { referrer } }}>{row[id]}</HoverLink>
                                </TableCell>
                            );
                        })}
                    </TableRow>
            ));

                return (
                    <Table<Discount> headCells={headCells}>{children}</Table>
                );
            }}
        </Query>
    );
};

export default DiscountTable;
